import { Button } from '@mantine/core';
import { IconFileSpreadsheet } from '@tabler/icons-react';

import { Id } from '@feature/utils';
import { ValidationStatus } from '@feature/validation';

interface ModelReportButtonProps {
  year: number;
  validationStatus: ValidationStatus | null;
  userId: Id | null;
}

const onDownload = (year: number, validationStatus: ValidationStatus | null, userId: Id | null) => {
  const userQuery = userId != null ? `&userId=${userId}` : '';
  const validationQuery = validationStatus != null ? `&validationStatus=${validationStatus}` : '';
  window.open(`/api/annual-report/generate/model-report/${year}?${userQuery}${validationQuery}`);
};

export function ModelReportButton({ year, validationStatus, userId }: ModelReportButtonProps) {
  return (
    <Button
      size="xs"
      leftSection={<IconFileSpreadsheet size="24px" />}
      onClick={() => onDownload(year, validationStatus, userId)}
    >
      Descarcă date conform modelului de raportare
    </Button>
  );
}
